module.exports = __webpack_public_path__ + "static/media/the-golden-age-of-aquarius.a36869f1.jpg";